export const executeWebtrekk = () => {
    try{
        var pageconfig = { 
            contentId: ""	
            }; 
            var wt = new window.webtrekkV3(pageconfig); 
            console.log("wt Value" ,wt);
            
            if(typeof(wt.sendinfo) != "undefined") wt.sendinfo(); 
        } catch (e) {
            console.log("Route change", e);
        }
}

export const executeWebtrekkMapp = () => {
    try{

        console.log("Change" );
        var pageconfig = { 
            contentId: "/pages/tax-disclaimer"	
            }; 
            var wt = new window.webtrekkV3(pageconfig); 
            console.log("wt change" ,wt);
            
            if(typeof(wt.sendinfo) != "undefined") wt.sendinfo(); 
        } catch (e) {
            console.log("Route change", e);
        }
}